export interface iExternalLinkIcon {
    isActive?: boolean;
}

export const ExternalLink = (props: iExternalLinkIcon) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 13L19.5 4.5" stroke={props.isActive ? "#1F1F1F" : "#808080"} strokeWidth="2"/>
        <path d="M13 4H20V11" stroke={props.isActive ? "#1F1F1F" : "#808080"} strokeWidth="2"/>
        <path d="M9.5 7H4V20H17V14" stroke={props.isActive ? "#1F1F1F" : "#808080"} strokeWidth="2"/>
        </svg>
    );
  };